const LayoutReports = ({ children }: any) => {
  return <div className="py-8 px-6 bg-color-light">{children}</div>;
};

export default LayoutReports;
